import { observer } from 'mobx-react';
import { T } from '../../../../Translations';

function InvitationsLink() {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://execonline.atlassian.net/l/cp/0s4pcLny"
      className="mt-2 block text-sm text-primary hover:opacity-80 transition-opacity"
      style={{ fontWeight: 'var(--font-weight-medium)' }}
    >
      <T kind="Preview the message and learn more about invitations" />
    </a>
  );
}

export default observer(InvitationsLink);
